import request from '@/utils/request'
import ObjectFunc from '@/tbs/util/ObjectFunc'

/**
 * The match section
 */
export function getMatchList(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/match/',
        method: 'get',
        params
    }) 
}
/**
 * The league section
 */
export function getLeagueList(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league/',
        method: 'get',
        params
    }) 
}

export function getLeagueListPagination(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league/pagination',
        method: 'get',
        params
    }) 
}

export function addLeague(data) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league/',
        method: 'post',
        data,
        params
    }) 
}

export function getLeague(id) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league/' + id,
        method: 'get',
        params
    }) 
}

export function deleteLeague(id) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league/' + id,
        method: 'delete',
        params
    }) 
}

export function updateLeague(data) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league/' + data.id,
        method: 'put',
        data,
        params
    }) 
}
/**
 * The league match section
 */
export function getLeagueMatchList(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league_match_relation/',
        method: 'get',
        params
    }) 
}

export function getLeagueMatchListPagination(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league_match_relation/pagination',
        method: 'get',
        params
    }) 
}

export function addLeagueMatch(data) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league_match_relation/',
        method: 'post',
        data,
        params
    }) 
}

export function getLeagueMatch(id) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league_match_relation/' + id,
        method: 'get',
        params
    }) 
}

export function deleteLeagueMatch(id) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league_match_relation/' + id,
        method: 'delete',
        params
    }) 
}

export function updateLeagueMatch(data) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/league_match_relation/' + data.id,
        method: 'put',
        data,
        params
    }) 
}
/**
 * The selection section
 */
export function getSelectionList(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_selection/',
        method: 'get',
        params
    }) 
}

export function getSelectionListPagination(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_selection/pagination',
        method: 'get',
        params
    }) 
}

export function addSelection(data) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_selection/',
        method: 'post',
        data,
        params
    }) 
}

export function getImportSelectionUrl() {
     return process.env.BJH_STATS_API + '/api/rpes/player_selection/?format=xlsx&accessKey=bjh-admin-rpes'
}

export function getImportSelectionTemplateUrl() {
     return process.env.BJH_STATS_API + '/api/res/template/player_selection_template.xlsx?accessKey=bjh-admin-rpes'
}

export function getSelection(id) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_selection/' + id,
        method: 'get',
        params
    }) 
}

export function deleteSelection(id) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_selection/' + id,
        method: 'delete',
        params
    }) 
}

export function updateSelection(data) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_selection/' + data.id,
        method: 'put',
        data,
        params
    }) 
}

export function getPlayerByCardNo(cardNo) {
    const params = {}
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player/' + cardNo,
        method: 'get',
        params
    }) 
}